<template v-if="data.helpers.notifications.unread"><span class="header__icon__bullet">{{data.helpers.notifications.unread}}</span></template>